import { makeStyles } from "@material-ui/core/styles";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  exhibitorContractorField: {
    textTransform: "uppercase",
    padding: theme.spacing(0.5, 1),
    borderRadius: "16px",
    backgroundColor: theme.palette.secondary.main,
    color: grey[500],
    letterSpacing: "0.5px",
    fontSize: "10px",
    lineHeight: "120%",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
  },
  continueModal: {
    position: "absolute",
    left: "40px",
    top: "-35px",
    fontSize: "10px",
    fontStyle: "normal",
    fontWeight: 400,
    color: "#FFF",
    lineHeight: "normal",
    letterSpacing: "0.4px",
    padding: theme.spacing(0.75),
    borderRadius: "4px",
    backgroundColor: "#616161",
    width: "max-content",
    zIndex: 10,
  },
}));
